import { action } from 'typesafe-actions';

const entity = 'registry';

const LOAD_REGISTRY = `${entity}/LOAD`;
const LOAD_REGISTRY_DONE = `${entity}/LOAD_DONE`;

const actionRegistryLoad = () =>
  action(LOAD_REGISTRY);
const actionRegistryLoaded = (rates: any) =>
  action(LOAD_REGISTRY_DONE, rates);


export {
  LOAD_REGISTRY,
  LOAD_REGISTRY_DONE,
  actionRegistryLoad,
  actionRegistryLoaded,
};